$('.js-anchor').click(anchorClick);

function scrollToAnchor(anchor, duration) {
    scrollToOffset(anchor == '#top' ? 0 : $(anchor).length ? $(anchor)[0].offsetTop : 0, duration);
}

function scrollToOffset(top, duration) {
    $('HTML,BODY').stop().animate({scrollTop: top}, duration);
}

export default function anchorClick(e) {
    let el = e.currentTarget;
    if ($($(el).prop('hash')).length || $(el).prop('hash') == '#top' || $(el).data('anchor')) {
        let hash = $(el).prop('hash') || $(el).data('anchor');

        $(el).data('anchor') || e.preventDefault();
        if ($(el).data('anchor-delay') != undefined) {
            setTimeout(function() {
                scrollToAnchor(hash, $(el).data('anchor-duration') != undefined ? $(el).data('anchor-duration') * 1000 : 1000);
            }, $(el).data('anchor-delay') * 1000);
        } else {
            scrollToAnchor(hash, 1000);
        }
    }
}


// WEBPACK FOOTER //
// ./_src/js/anchor.js